/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

export default class TermsPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <section className="container mx-auto px-4 md:px-12 py-16 lg:py-24">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-theme-blue font-bold leading-tight mb-8">
              Terms & Conditions
            </h1>
            <div className="text-lg text-gray-500 font-light leading-relaxed space-y-6">
              <p>
                Welcome to Drava Studio. These terms and conditions outline the rules and regulations for the use of Drava Studio's Website and Services.
              </p>
              
              <h2 className="text-2xl font-semibold text-theme-blue mt-8 mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing this website we assume you accept these terms and conditions. Do not continue to use Drava Studio if you do not agree to take all of the terms and conditions stated on this page.
              </p>

              <h2 className="text-2xl font-semibold text-theme-blue mt-8 mb-4">2. License</h2>
              <p>
                Unless otherwise stated, Drava Studio and/or its licensors own the intellectual property rights for all material on Drava Studio. All intellectual property rights are reserved. You may access this from Drava Studio for your own personal use subjected to restrictions set in these terms and conditions.
              </p>

              <h2 className="text-2xl font-semibold text-theme-blue mt-8 mb-4">3. User Comments</h2>
              <p>
                Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Drava Studio does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Drava Studio, its agents and/or affiliates.
              </p>

              <h2 className="text-2xl font-semibold text-theme-blue mt-8 mb-4">4. Hyperlinking to our Content</h2>
              <p>
                The following organizations may link to our Website without prior written approval: Government agencies, Search engines, News organizations, Online directory distributors.
              </p>
              
              <p className="mt-8 text-sm">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }
}
